module.exports = __webpack_public_path__ + "static/img/10.9968bb5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/sp/10.png
// module id = i8hp
// module chunks = 0